import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.jobTitles',
    'resource:data.dimensions.jobTitles.entities.jobTitle',
    'resource:data.dimensions.organization',
    'resource:data.dimensions.organization.entities.department',
    'resource:data.dimensions.organization.entities.subdepartment',
    'resource:data.dimensions.personnel',
    'resource:data.dimensions.personnel.entities.employee',
    'resource:data.dimensions.personnel.entities.employee.attributes.jobTitle',
    'resource:data.dimensions.personnel.entities.employee.attributes.organization',
    'resource:data.dimensions.personnelLeaders',
    'resource:data.dimensions.personnelLeaders.entities.relationship',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.leader',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.personnel',
    'resource:data.dimensions.personas',
    'resource:data.dimensions.personas.entities.persona',
    'resource:data.dimensions.stakeholders',
    'resource:data.dimensions.stakeholders.entities.stakeholder',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.adoptionReadinessRisk',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.changeChampion',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.commAudience',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.concernsRisks',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.degreeOfImpact',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.department',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.employee',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.engagementNeeded',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.influenceDecisionRole',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.isProjectTeamMember',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.jobTitle',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.notesFollowUp',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.perceivedAttitude',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.permissionSets',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.persona',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.projectRole',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.subdepartment',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.supportNeeds',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.systemUserRole',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.trainingAudienceNeed',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.understanding',
    'resource:data.dimensions.stakeholders.entities.stakeholder.attributes.validationStatus',
    'resource:data.enums.changeImpactRank',
    'resource:data.enums.changeImpactRank.entries.high',
    'resource:data.enums.changeImpactRank.entries.medium',
    'resource:data.enums.changeImpactRank.entries.low',
    'resource:data.enums.changeImpactValidationStatus',
    'resource:data.enums.changeImpactValidationStatus.entries.notStarted',
    'resource:data.enums.changeImpactValidationStatus.entries.inProgress',
    'resource:data.enums.changeImpactValidationStatus.entries.completed',
    'resource:data.enums.stakeholderChangeChampion',
    'resource:data.enums.stakeholderChangeChampion.entries.no',
    'resource:data.enums.stakeholderChangeChampion.entries.notApplicable',
    'resource:data.enums.stakeholderChangeChampion.entries.potential',
    'resource:data.enums.stakeholderChangeChampion.entries.yes',
    'resource:data.enums.stakeholderEngagementNeeded',
    'resource:data.enums.stakeholderEngagementNeeded.entries.awarenessOnly',
    'resource:data.enums.stakeholderEngagementNeeded.entries.highTouchIndividual',
    'resource:data.enums.stakeholderEngagementNeeded.entries.standardGroupEngagement',
    'resource:data.enums.stakeholderEngagementNeeded.entries.targetedGroupEngagement',
    'resource:data.enums.stakeholderPerceivedAttitude',
    'resource:data.enums.stakeholderPerceivedAttitude.entries.negative',
    'resource:data.enums.stakeholderPerceivedAttitude.entries.neutral',
    'resource:data.enums.stakeholderPerceivedAttitude.entries.positive',
    'resource:data.enums.stakeholderPerceivedAttitude.entries.unknown',
    'resource:data.enums.stakeholderProjectRole',
    'resource:data.enums.stakeholderProjectRole.entries.changeChampion',
    'resource:data.enums.stakeholderProjectRole.entries.endUser',
    'resource:data.enums.stakeholderProjectRole.entries.executiveSponsor',
    'resource:data.enums.stakeholderProjectRole.entries.externalStakeholder',
    'resource:data.enums.stakeholderProjectRole.entries.managerPeopleLeader',
    'resource:data.enums.stakeholderProjectRole.entries.other',
    'resource:data.enums.stakeholderProjectRole.entries.projectTeam',
    'resource:data.enums.stakeholderProjectRole.entries.sponsorLeader',
    'resource:data.enums.stakeholderProjectRole.entries.steeringCommittee',
    'resource:data.enums.stakeholderProjectRole.entries.subjectMatterExpert',
    'resource:data.enums.stakeholderProjectRole.entries.supportAdministration',
    'resource:data.enums.stakeholderProjectRole.entries.workstreamLead',
    'resource:data.enums.stakeholderTrainingAudience',
    'resource:data.enums.stakeholderTrainingAudience.entries.jobAidPerformanceSupport',
    'resource:data.enums.stakeholderTrainingAudience.entries.noTrainingExpected',
    'resource:data.enums.stakeholderTrainingAudience.entries.overviewAwareness',
    'resource:data.enums.stakeholderTrainingAudience.entries.roleBasedTraining',
    'resource:data.enums.stakeholderTrainingAudience.entries.trainTheTrainerSuperUser',
    'resource:solutions.apps.stakeholderAnalysis',
    'resource:solutions.apps.stakeholderAnalysis.pages.dashboard',
    'resource:solutions.apps.stakeholderAnalysis.pages.stakeholderLog',
    'resource:solutions.apps.stakeholderAnalysis.pages.stakeholders',
    'resource:solutions.apps.stakeholderAnalysis.pages.details',
    'resource:solutions.mosaic.actions.stakeholderAnalysis.saveStakeholder',
    'resource:solutions.mosaic.pages.stakeholderAnalysis.dashboard',
    'resource:solutions.mosaic.pages.stakeholderAnalysis.details',
    'resource:solutions.mosaic.pages.stakeholderAnalysis.stakeholderLog',
    'resource:solutions.mosaic.pages.stakeholderAnalysis.stakeholders',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.createStakeholderModal',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.editStakeholderModal',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.highPriorityTable',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.stakeholderDetails',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.stakeholderDetailsModal',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.stakeholderLog',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.stakeholdersByEngagementLevel',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.stakeholdersByImpactAndInfluence',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.stakeholdersBySentiment',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.stakeholdersBySupportLevel',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.stakeholdersByUnderstanding',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.stakeholdersByValidationStatus',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.stakeholdersTable',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.suggestedEngagementActionsByOwner',
    'resource:solutions.mosaic.widgets.stakeholderAnalysis.supportNeedsByDepartment',
  ],
  description:
    'A package containing entities and resources specific to the Stakeholder Analysis application.',
  name: 'Stakeholder Analysis',
} as const satisfies core.quiver.Package
